import { INCIDENT_MANAGEMENT as type } from "../actions/types.js";

const statusList = {
  incidentLevelList: [],
  sourceList: [],
  incidentTypeList: [],
  actionRequiredList: [],
  causedByList: [],
  rootCauseList: [],
  resultList: [],
  actionResultList: [],
  correctiveActionList: [],
  reviewTypeList: [],
  incidentStatusList: [],
}

const initialState = {
  statusList: statusList,
  loading: false,
  investigationListLoading: false,
  investigationList: [],
  investigationError: false,
  investigationTable: {
    currentPage: 1,
    lastPage: 1,
    perPage: 20,
    total: 0,
  },
  incidentCount: {
    warehouses: [],
    users: []
  }
}

function incidentManagementReducer(state = initialState, action) {
  switch(action.type) {
    case type.GET_ALL_DROP_DOWNS:
      return {
        ...state,
        loading: true
      }
    case type.GET_ALL_DROP_DOWNS_SUCCESS:
      return {
        ...state,
        loading: false,
        statusList: {
          incidentStatusList: action.payload.status,
          incidentLevelList: action.payload.level,
          sourceList: action.payload.source,
          incidentTypeList: action.payload.type,
          actionRequiredList: action.payload.action,
          rootCauseList: action.payload.root_cause,
          resultList: action.payload.result_type,
          actionResultList: action.payload.action_result,
          causedByList: action.payload.caused_by,
          correctiveActionList: action.payload.corrective_action,
          reviewTypeList: action.payload.review_type,
        }
      }
    case type.GET_ALL_DROP_DOWNS_FAIL:
      return {
        ...state,
        loading: false,
      }
    case type.GET_INVESTIGATIONS:
      return {
        ...state,
        investigationListLoading: true,
        investigationList: [],
        investigationError: false,
      }
    case type.GET_INVESTIGATIONS_SUCCESS:
      return {
        ...state,
        investigationListLoading: false,
        investigationList: action.payload.data,
        investigationTable: {
          currentPage: action.payload.current_page,
          lastPage: action.payload.last_page,
          perPage: action.payload.per_page,
          total: action.payload.total,
        },
      }
    case type.GET_INVESTIGATIONS_FAIL:
      return {
        ...state,
        investigationListLoading: false,
        investigationError: true,
      }
    case type.CREATE_NEW_INCIDENT:
    case type.UPDATE_BASIC_INCIDENT:
    case type.UPDATE_INPROGRESS_INCIDENT:
    case type.CLOSE_INVESTIGATION:
    case type.DOWNLOAD_INCIDENT_EXCEL:
      return {
        ...state,
        loading: true
      }
    case type.CREATE_NEW_INCIDENT_SUCCESS:
    case type.UPDATE_BASIC_INCIDENT_SUCCESS:
    case type.UPDATE_INPROGRESS_INCIDENT_SUCCESS:
    case type.CLOSE_INVESTIGATION_SUCCESS:
    case type.DOWNLOAD_INCIDENT_EXCEL_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case type.CREATE_NEW_INCIDENT_FAIL:
    case type.UPDATE_BASIC_INCIDENT_FAIL:
    case type.UPDATE_INPROGRESS_INCIDENT_FAIL:
    case type.CLOSE_INVESTIGATION_FAIL:
    case type.DOWNLOAD_INCIDENT_EXCEL_FAIL:
      return {
        ...state,
        loading: false
      }
    case type.GET_WAREHOUSE_INCIDENT_COUNT:
      return {
        ...state,
        loading: true,
      }
    case type.GET_WAREHOUSE_INCIDENT_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        incidentCount: {
          ...state.incidentCount,
          warehouses: action.payload
        }
      }
    case type.GET_WAREHOUSE_INCIDENT_COUNT_FAIL:
      return {
        ...state,
        loading: false,
      }
    case type.BATCH_CLOSE_INCIDENT:
      return {
        ...state,
        loading: true,
      }
    case type.BATCH_CLOSE_INCIDENT_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case type.BATCH_CLOSE_INCIDENT_FAIL:
      return {
        ...state,
        loading: false
      }
    default:
      return state
  }
}

export default incidentManagementReducer